import PropTypes from 'prop-types';

export const distributionData = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string,
    percentage: PropTypes.number,
  }),
);
